import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Columns } from './style'

const GridColumns = (props) => {
    const { children, cols, classes } = props

    const className = classNames(Columns[cols], classes)

    return <div className={className}>{children}</div>
}

GridColumns.propTypes = {
    cols: PropTypes.number,
    children: PropTypes.any,
}

export default GridColumns
